module.exports = __webpack_public_path__ + "static/media/bg@2x.5e7fb95b.png";